// extracted by mini-css-extract-plugin
export var centerText = "_co-8";
export var container = "_co-0";
export var doughnutContainer = "_co-7";
export var legend = "_co-a";
export var legendItemColorDisplay = "_co-b";
export var legendItemLabel = "_co-d";
export var legendItemValue = "_co-c";
export var lg = "_co-5";
export var maxWidth = "_co-9";
export var md = "_co-4";
export var responsive = "_co-6";
export var sm = "_co-3";
export var xs = "_co-2";
export var xxs = "_co-1";